import React from 'react';
import Select from 'react-select';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProfileSubmitToastSlot = ({
  children,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      position: 'relative',
      width: '100%',
      maxWidth: 420,
      margin: '0 auto 8px',
      zIndex: 5,
      ...rest.style
    }}
  >
    <style>{`
      .profile-submit-toast-slot .Toastify__toast-container {
        position: relative !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        left: auto !important;
        transform: none !important;
        width: 100% !important;
        padding: 0 !important;
      }
      .profile-submit-toast-slot .Toastify__toast {
        margin-bottom: 0.5rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    `}</style>
    <div className="profile-submit-toast-slot">{children}</div>
  </div>
);

const ProfileScreen = ({
  isAuthenticated,
  showWelcomeScreen,
  profileAllow,
  profileFilled,
  profileStep,
  setProfileStep,
  // Step 1 props
  staticForm,
  staticFormErrors,
  handleStaticFormChange,
  handleStaticFormSubmit,
  genderOptions,
  yesOrNoOptions,
  centerOptions,
  isIosSafari,
  selectedDate,
  isPickerOpen,
  setIsPickerOpen,
  handleDateChange,
  TextInputWrapper,
  customSelectStyles,
  // Step 2 props
  step2Form,
  step2Errors,
  handleStep2Change,
  handleStep2Submit,
  getProductOptions,
  educationOptions,
  profileSubmitToastContainerId = 'weblink-profile-submit-toast'
}) => {
  if (!isAuthenticated || showWelcomeScreen || !profileAllow || profileFilled) return null;

  return (
    <>
      {profileStep === 1 && (
        <form onSubmit={handleStaticFormSubmit} style={{ marginBottom: 32, background: '#f9f9f9', padding: 24, borderRadius: 8, marginTop: 65 }}>
          <h5><strong>Profile</strong> &gt; Getting started <span style={{ color: '#9ebe21' }}>1/2</span></h5>
          <div style={{ width: '100%', height: '8px', backgroundColor: '#e0e0e0', borderRadius: '4px', margin: '12px 0' }}>
            <div style={{ width: '50%', height: '100%', backgroundColor: '#9ebe21', borderRadius: '4px', transition: 'width 0.3s ease' }} />
          </div>
          <h7><strong>Tell us about yourself</strong></h7>

          <div style={{ marginBottom: 16, marginTop: 4 }}>
            <label>What's your name?</label><br />
            <TextInputWrapper
              question={{ question_ID: 'profile_name', questionType_ID: 5, questionName: 'Name', isRequired: true }}
              value={staticForm.name}
              onSave={val => handleStaticFormChange('name', val)}
            />
            {(() => {
              const saved = JSON.parse(localStorage.getItem('text_input_answers') || '{}');
              return !saved['profile_name'] && staticFormErrors.name ? <div style={{ color: 'red' }}>{staticFormErrors.name}</div> : null;
            })()}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>And your Date of Birth?</label><br />
            {isIosSafari() ? (
              <>
                <div
                  onClick={() => setIsPickerOpen(true)}
                  style={{ width: '100%', padding: 8, fontSize: 16, border: '1px solid #ccc', borderRadius: 4, backgroundColor: '#fff', cursor: 'pointer' }}
                >
                  {staticForm.dateOfBirth || 'Select Date'}
                </div>
                {/* Expect parent to render MobileDatePicker globally when isPickerOpen true */}
              </>
            ) : (
              <input
                type="date"
                value={(() => {
                  if (!staticForm.dateOfBirth) return '';
                  const parts = staticForm.dateOfBirth.split('/');
                  if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
                  return staticForm.dateOfBirth;
                })()}
                onChange={e => handleStaticFormChange('dateOfBirth', e.target.value)}
                max={(() => {
                  const today = new Date();
                  today.setDate(today.getDate() - 1);
                  return today.toISOString().split('T')[0];
                })()}
                min={(() => {
                  const date = new Date();
                  date.setFullYear(date.getFullYear() - 100);
                  return date.toISOString().split('T')[0];
                })()}
                style={{ width: '100%', padding: 8, fontSize: 16, border: '1px solid #ccc', borderRadius: 4, WebkitAppearance: 'menulist' }}
              />
            )}
            {staticFormErrors.dateOfBirth && <div style={{ color: 'red' }}>{staticFormErrors.dateOfBirth}</div>}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Tell us are you:</label><br />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem', marginTop: 8 }}>
              {genderOptions.map(opt => {
                const isSelected = staticForm.gender_ID == opt.value;
                return (
                  <div
                    key={opt.value}
                    onClick={() => handleStaticFormChange('gender_ID', opt.value)}
                    style={{ padding: '0.75rem', border: isSelected ? '2px solid #9ebe21' : '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', backgroundColor: isSelected ? '#fff' : 'rgb(239 239 239)', fontWeight: isSelected ? 600 : 400, textAlign: 'left' }}
                  >
                    {opt.label}
                  </div>
                );
              })}
            </div>
            {staticFormErrors.gender_ID && <div style={{ color: 'red' }}>{staticFormErrors.gender_ID}</div>}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>And, are you married?</label><br />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem', marginTop: 8 }}>
              {yesOrNoOptions.map(opt => {
                const isSelected = staticForm.isMarried === opt.value;
                return (
                  <div
                    key={opt.value}
                    onClick={() => handleStaticFormChange('isMarried', opt.value)}
                    style={{ padding: '0.75rem', border: isSelected ? '2px solid #9ebe21' : '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', backgroundColor: isSelected ? '#fff' : 'rgb(239 239 239)', fontWeight: isSelected ? 600 : 400, textAlign: 'left' }}
                  >
                    {opt.label}
                  </div>
                );
              })}
            </div>
            {staticFormErrors.isMarried && <div style={{ color: 'red' }}>{staticFormErrors.isMarried}</div>}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Where do you live?</label><br />
            <Select
              options={centerOptions}
              value={centerOptions.find(opt => opt.value === staticForm.center_ID)}
              onChange={(selected) => handleStaticFormChange('center_ID', selected?.value)}
              placeholder="Select"
              styles={customSelectStyles}
              menuPlacement="bottom"
              menuPosition="absolute"
            />
            {staticFormErrors.center_ID && <div style={{ color: 'red' }}>{staticFormErrors.center_ID}</div>}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Enter Pin Code</label><br />
            <TextInputWrapper
              question={{ question_ID: 'profile_pincode', questionType_ID: 11, questionName: 'Pin Code', isRequired: true }}
              value={staticForm.address}
              onSave={val => {
                const numericVal = val.replace(/\D/g, '').slice(0, 6);
                handleStaticFormChange('address', numericVal);
              }}
            />
            {staticFormErrors.address ? <div style={{ color: 'red' }}>{staticFormErrors.address}</div> : null}
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
            <button type="submit" style={{ padding: '8px 24px', background: '#9ebe21', color: '#fff', border: 'none', borderRadius: 4 }}>Next</button>
          </div>
        </form>
      )}

      {profileStep === 2 && (
        <form onSubmit={handleStep2Submit} style={{ marginBottom: 32, padding: 24, borderRadius: 8, marginTop: 65 }}>
          <h5><strong>Profile</strong> &gt; Two Questions Left <span style={{ color: '#9ebe21' }}>2/2</span></h5>
          <div style={{ width: '100%', height: '8px', backgroundColor: '#e0e0e0', borderRadius: '4px', margin: '12px 0' }}>
            <div style={{ width: '100%', height: '100%', backgroundColor: '#9ebe21', borderRadius: '4px', transition: 'width 0.3s ease' }} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>The education for your family's primary earning member is:</label><br />
            <Select
              options={educationOptions}
              value={educationOptions.find(opt => opt.value === step2Form.parentEducation_ID) || null}
              onChange={selected => handleStep2Change('parentEducation_ID', selected?.value)}
              placeholder="Select"
              styles={customSelectStyles}
              menuPlacement="auto"
              menuPosition="absolute"
            />
            {step2Errors.parentEducation_ID && <div style={{ color: 'red' }}>{step2Errors.parentEducation_ID}</div>}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Pick all the products you use at home:</label><br />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem', marginTop: 8 }}>
              {getProductOptions().map(opt => {
                const isSelected = step2Form.HomeProduct.includes(opt.id.toString()) || step2Form.HomeProduct.includes(opt.id);
                return (
                  <div
                    key={opt.id}
                    onClick={() => {
                      let newProducts = Array.isArray(step2Form.HomeProduct) ? [...step2Form.HomeProduct] : [];
                      const value = opt.id.toString();
                      if (newProducts.includes(value)) {
                        newProducts = newProducts.filter(p => p !== value);
                      } else {
                        newProducts.push(value);
                      }
                      handleStep2Change('HomeProduct', newProducts);
                    }}
                    style={{ padding: '0.75rem', border: isSelected ? '2px solid #9ebe21' : '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', backgroundColor: isSelected ? '#fff' : 'rgb(239 239 239)', fontWeight: isSelected ? 600 : 400, textAlign: 'left' }}
                  >
                    {opt.label}
                  </div>
                );
              })}
            </div>
            {step2Errors.HomeProduct && <div style={{ color: 'red' }}>{step2Errors.HomeProduct}</div>}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 24 }}>
            <ProfileSubmitToastSlot>
              <ToastContainer
                enableMultiContainer
                containerId={profileSubmitToastContainerId}
                position="top-center"
                autoClose={4000}
                closeOnClick
                pauseOnHover
                transition={Zoom}
                draggable={false}
                hideProgressBar={true}
              />
            </ProfileSubmitToastSlot>
            <button type="submit" style={{ padding: '8px 24px', background: '#9ebe21', color: '#fff', border: 'none', borderRadius: 4, marginBottom: 12 }}>Submit</button>
            <button onClick={() => setProfileStep(1)} style={{ padding: '8px 24px', background: '#FFFFFF', color: '#9ebe21', border: 'none', borderRadius: 4 }}>Go Back</button>
          </div>
        </form>
      )}
    </>
  );
};

export default ProfileScreen;


